import { DROPanel } from '@/components/DROPanel/DROPanel';
import { JogPanel } from '@/components/JogPanel/JogPanel';
import { GCodePanel } from '@/components/GCodePanel/GCodePanel';

export function HomePage(): JSX.Element {
  return (
    <>
      <DROPanel />
      <JogPanel />
      <GCodePanel />
    </>
  );
}
